/** Shared nav keys for the bay console rail and mechanic access. */
export const DESK_TABS = [
  // Workshop: what mechanics and the front desk use all day.
  { id: 'floor', to: '/', labelKey: 'nav.floor', icon: 'today', end: true, group: 'workshop' },
  { id: 'bookings', to: '/bookings', labelKey: 'nav.bookings', icon: 'build', group: 'workshop' },
  { id: 'customers', to: '/customers', labelKey: 'nav.customers', icon: 'group', group: 'workshop' },
  { id: 'resale', to: '/resale-inspections', labelKey: 'nav.resale', icon: 'fact_check', group: 'workshop' },
  // Office: admin, money and settings.
  { id: 'services', to: '/services', labelKey: 'nav.services', icon: 'menu_book', group: 'office' },
  { id: 'finances', to: '/finances', labelKey: 'nav.finances', icon: 'payments', group: 'office' },
  { id: 'reviews', to: '/reviews', labelKey: 'nav.reviews', icon: 'reviews', group: 'office' },
  { id: 'mechanic-activity', to: '/mechanic-activity', labelKey: 'nav.mechanicActivity', icon: 'engineering', group: 'office' },
  { id: 'management', to: '/management', labelKey: 'nav.management', icon: 'settings', group: 'office' },
];

export const NAV_GROUPS = ['workshop', 'office'];

export const DESK_TAB_IDS = DESK_TABS.map((tab) => tab.id);

/** Default tabs when an admin has not set desk_tabs yet (legacy = unrestricted). */
export const DEFAULT_MECHANIC_TABS = ['floor', 'bookings'];

/** Advisors default to the floor console, not workshop setup. */
export const DEFAULT_ADVISOR_TABS = DESK_TABS
  .filter((tab) => tab.id !== 'management')
  .map((tab) => tab.id);

export function normalizeDeskTabs(value) {
  if (!Array.isArray(value)) return null;
  const allowed = new Set(DESK_TAB_IDS);
  const next = [...new Set(value.filter((id) => allowed.has(id)))];
  return next.length ? next : null;
}

export function defaultTabsForRole(role) {
  if (role === 'technician') return [...DEFAULT_MECHANIC_TABS];
  if (role === 'advisor') return [...DEFAULT_ADVISOR_TABS];
  return [...DESK_TAB_IDS];
}

/**
 * Managers always see every tab.
 * Advisors and technicians: null desk_tabs = all (legacy); otherwise only listed keys.
 */
export function tabsForProfile(profile) {
  if (!profile) return DESK_TABS;
  if (profile.role === 'manager') return DESK_TABS;
  if (profile.role !== 'advisor' && profile.role !== 'technician') return DESK_TABS;
  const keys = normalizeDeskTabs(profile.desk_tabs);
  if (!keys) return DESK_TABS;
  return DESK_TABS.filter((tab) => keys.includes(tab.id));
}

export function canAccessPath(profile, pathname) {
  const tabs = tabsForProfile(profile);
  if (pathname === '/' || pathname === '') {
    return tabs.some((tab) => tab.id === 'floor');
  }
  return tabs.some((tab) => {
    if (tab.to === '/') return false;
    return pathname === tab.to || pathname.startsWith(`${tab.to}/`);
  });
}

export function firstAllowedPath(profile) {
  const tabs = tabsForProfile(profile);
  return tabs[0]?.to || '/';
}
